import TaxHint from '@/components/Blue/TaxHint.vue';
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import FormattedPrice from '@/components/Base/Formats/FormattedPrice.vue';
import FormattedDate from '@/components/Base/Formats/FormattedDate.vue';
import eventBus from '@/services/EventBus';
import OpenPopupButton from '@/components/PopUps/OpenPopupButton.vue';
export default defineComponent({
    name: 'ProductBoxBig',
    components: { OpenPopupButton, FormattedPrice, FormattedDate, TaxHint },
    props: {
        index: {
            type: Number,
            required: true,
        },
        cartItem: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            edit_quantity: null,
        };
    },
    computed: {
        original_price() {
            return this.cartItem.original_price * this.cartItem.quantity;
        },
        deal_price() {
            var _a;
            return ((_a = this.cartItem.bd_price) !== null && _a !== void 0 ? _a : 0) * this.cartItem.quantity;
        },
        total_price() {
            return this.cartItem.price * this.cartItem.quantity;
        },
        current_quantity: {
            get: function () {
                var _a;
                return (_a = this.edit_quantity) !== null && _a !== void 0 ? _a : this.cartItem.quantity;
            },
            set: function (new_quantity) {
                this.edit_quantity = new_quantity;
            },
        },
    },
    methods: Object.assign({ increment() {
            const target = this.current_quantity + 1;
            if (target > this.cartItem.stock_available) {
                return;
            }
            this.setProductQuantity({
                product_id: this.cartItem.id,
                quantity: this.current_quantity + 1,
            });
        },
        decrement() {
            const target = this.current_quantity - 1;
            if (target < 1) {
                return;
            }
            this.setProductQuantity({
                product_id: this.cartItem.id,
                quantity: this.current_quantity - 1,
            });
        },
        showConditions() {
            eventBus.emit('openConditionsInfoModal');
        },
        removeProduct() {
            this.removeCartItem(this.cartItem.id);
        } }, mapActions('blue', {
        removeCartItem: 'REMOVE_PRODUCT',
        setProductQuantity: 'SET_QUANTITY',
    })),
    watch: {
        modelValue: function () {
            this.edit_quantity = null;
        },
    },
});
